<template>
  <!--====== OFFCANVAS MENU PART START ======-->
  <div>
    <div
      class="off_canvars_overlay"
      :class="[sidebar ? 'active' : '']"
      @click.prevent="hideSidebar"
    ></div>
    <div class="offcanvas_menu">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div
              class="offcanvas_menu_wrapper"
              :class="[sidebar ? 'active' : '']"
              style="overflow-y: scroll; overflow-x: hidden"
            >
              <div class="canvas_close">
                <a href="javascript:void(0)" @click="hideSidebar">
                  <i class="fa fa-times"></i>
                </a>
              </div>

              <div class="offcanvas-brand text-center mb-40">
                <img 
                  :src="require('@/assets/images/logo2.png')" 
                  alt="logo" 
                  style="width: 80px;"
                />
              </div>

              <div id="menu" :style="heightPro" class="text-left">
                <ul class="offcanvas_main_menu list-unstyled">
                  <!-- 一级菜单循环 -->
                  <li
                    v-for="(item, index) in menuItems"
                    :key="index"
                    class="menu-item-has-children"
                    :class="[menuOpen === item.linkText ? 'menu-open' : '']"
                  >
                    <!-- 移除整行点击事件，仅箭头控制展开 -->
                    <div class="menu-item-row d-flex justify-content-between align-items-center">
                      <template v-if="item.submenu && item.submenu.length > 0">
                        <span class="menu-text">{{ $t(item.linkText) }}</span>
                        <!-- 仅箭头绑定展开逻辑 -->
                        <span class="menu-expand" @click.stop.prevent="show(item.linkText)">
                          <i class="fa fa-angle-down"></i>
                        </span>
                      </template>

                      <router-link
                        v-else
                        class="menu-text"
                        :to="item.link"
                      >
                        {{ $t(item.linkText) }}
                      </router-link>
                    </div>

                    <!-- 二级子菜单 -->
                    <ul
                      v-if="item.submenu && nasted"
                      :id="item.linkText"
                      class="sidebar-sub-menu list-unstyled"
                      :class="[menuOpen === item.linkText ? 'expend_menu_item' : '']"
                    >
                      <li v-for="(subItem, subIdx) in item.submenu" :key="subIdx">
                        <router-link :to="subItem.link ? subItem.link : '#'">
                          {{ $t(subItem.linkText) }}
                        </router-link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>

              <!-- 移动端侧边栏语言切换 -->
              <div class="offcanvas-lang-switch mt-40 text-center">
                <div class="lang-btn-group d-inline-flex">
                  <button 
                    class="lang-btn"
                    :class="[currentLang === 'zh-cn' ? 'lang-active' : '']"
                    @click.stop.prevent="changeLocale('zh-cn')"
                  >
                    {{ $t('lang.zh') }}
                  </button>
                  <button 
                    class="lang-btn"
                    :class="[currentLang === 'en' ? 'lang-active' : '']"
                    @click.stop.prevent="changeLocale('en')"
                  >
                    {{ $t('lang.en') }}
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--====== OFFCANVAS MENU PART ENDS ======-->
</template>

<script>
import Navs from "../Data/NavItems";
export default {
  props: {
    sidebar: {
      type: Boolean,
      required: true,
    },
    nasted: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      menuOpen: null,
      subMenuHeight: null,
      menuItems: Navs.data,
      currentLang: localStorage.getItem('locale') || 'zh-cn'
    };
  },
  inject: [],
  computed: {
    heightPro() {
      return {
        "--height": this.subMenuHeight,
      };
    },
  },
  methods: {
    hideSidebar(e) {
      this.$emit("toggleSidebar", e);
    },
    // 修复展开逻辑、DOM获取容错
    show(value) {
      // 点击同一菜单直接关闭
      if (value === this.menuOpen) {
        this.menuOpen = null;
        this.subMenuHeight = "0px";
        return;
      }
      // 打开目标菜单
      this.menuOpen = value;
      this.$nextTick(() => {
        // 精准获取当前对应子菜单容器
        const subWrap = document.getElementById(value);
        if (!subWrap) {
          this.subMenuHeight = "0px";
          return;
        }
        const liList = subWrap.querySelectorAll("li");
        this.subMenuHeight = liList.length * 48 + "px";
      });
    },
    changeLocale(lang) {
      if (this.currentLang === lang) return;
      this.currentLang = lang;
      localStorage.setItem('locale', lang);
      if (this.$i18n) {
        this.$i18n.locale = lang;
      }
    }
  },
};
</script>

<style>
/* 原有遮罩不动 */
.off_canvars_overlay {
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}
.off_canvars_overlay.active {
  opacity: 1;
  visibility: visible;
}

/* 最高权重重置菜单默认边距、线条 */
#menu .offcanvas_main_menu.list-unstyled {
  margin: 0 !important;
  padding: 0 !important;
}
#menu .offcanvas_main_menu > li.menu-item-has-children {
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
}

/* ==========一级菜单统一（首页/会议信息/参会投稿完全一致）========== */
#menu .menu-item-row.d-flex {
  width: 100% !important;
  height: 56px !important;
  padding: 0 30px !important;
  margin: 0 !important;
  /* 只保留底部一条分割线，杜绝多重线条 */
  border-bottom: 1px solid #e6e6e6 !important;
  border-top: none !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  cursor: pointer;
}
#menu .menu-item-row.d-flex:hover {
  background: #f7f7f7 !important;
}

/* 一级菜单文字统一字号、垂直居中，消除首页和会议信息差异 */
#menu .menu-text {
  font-size: 14px !important; /* 缩小字体 */
  color: #222 !important;
  font-weight: 500 !important;
  text-decoration: none !important;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: flex !important;
  align-items: center !important;
  height: 100% !important;
}

/* 下拉箭头容器不破坏行高 */
#menu .menu-expand {
  width: 56px !important;
  height: 100% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #777 !important;
  transition: transform 0.3s ease !important;
}
#menu .menu-item-has-children.menu-open .menu-expand {
  transform: rotate(180deg) !important;
}

/* ==========二级子菜单修复：解决双下划线、字号、对齐========== */
#menu .sidebar-sub-menu.list-unstyled {
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden;
  height: 0;
  transition: height 0.35s ease;
  border: none !important;
}
#menu .sidebar-sub-menu.expend_menu_item {
  height: var(--height) !important;
}
#menu .sidebar-sub-menu > li {
  height: 48px !important;
  margin: 0 !important;
  padding: 0 30px 0 52px !important;
  /* 关键：只留底部一条边框，清除自带上边距线条，解决双下划线 */
  border-bottom: 1px solid #e6e6e6 !important;
  border-top: none !important;
  display: flex !important;
  align-items: center !important;
}
/* 最后一条子项去掉底边框，避免多余线条 */
#menu .sidebar-sub-menu > li:last-child {
  border-bottom: none !important;
}
#menu .sidebar-sub-menu a {
  width: 100%;
  height: 100%;
  font-size: 13px !important; /* 二级菜单字号比一级略小，层级区分 */
  color: #222 !important;
  text-decoration: none !important;
  display: flex !important;
  align-items: center !important;
  /* 清除a标签自带底线 */
  border-bottom: none !important;
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
}
.offcanvas_main_menu li a {
  border-bottom: none !important;
}

/* 底部区域样式保留 */
.offcanvas-lang-switch {
  margin-top: 32px;
  padding-top: 24px;
}
.lang-trigger-mobile {
  font-size: 16px;
  cursor: pointer;
  padding: 8px 12px;
}
.mobile-lang-sub li {
  padding: 10px 0;
  font-size: 15px;
  cursor: pointer;
}
.footer-widget-info {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #f0f0f0;
}
.footer-widget-info li {
  margin-bottom: 12px;
  font-size: 15px;
}
/* 语言切换按钮组样式 */
.lang-btn-group {
  border: 1px solid #ddd;
  border-radius: 6px;
  overflow: hidden;
}
.lang-btn {
  width: 86px;
  height: 40px;
  border: none;
  background: #fff;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;
}
/* 左右按钮去除中间边框缝隙 */
.lang-btn:first-child {
  border-right: 1px solid #ddd;
}
/* 选中高亮样式 */
.lang-btn.lang-active {
  background: #222;
  color: #fff;
}
.lang-btn:hover:not(.lang-active) {
  background: #f5f5f5;
}
#menu .sidebar-sub-menu > li:last-child {
  border-bottom: 1px solid #e6e6e6 !important;
}
</style>